"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = void 0;
Object.defineProperty(exports, "ShadowScrollbars", {
  enumerable: true,
  get: function get() {
    return _shadowScrollbar["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _raf = _interopRequireWildcard(require("raf"));
var _domCss = _interopRequireDefault(require("dom-css"));
var _size = _interopRequireDefault(require("../utilities/size/"));
var _position = _interopRequireDefault(require("../utilities/position"));
var _utilities = require("../utilities");
var _scrollbarModule = _interopRequireDefault(require("./scrollbar.module.scss"));
var _shadowScrollbar = _interopRequireDefault(require("./shadowScrollbar"));
var _excluded = ["onScroll", "onScrollFrame", "onScrollStart", "onScrollStop", "onUpdate", "tagName", "autoHide", "autoHideTimeout", "autoHideDuration", "thumbSize", "thumbMinSize", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "trackPadding", "trackBackground", "children", "fireWindowScrollEvents"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Scrollbars = exports.Scrollbars = /*#__PURE__*/function (_Component) {
  function Scrollbars() {
    var _this;
    _classCallCheck(this, Scrollbars);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Scrollbars, [].concat(args));
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "container", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "view", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "trackHorizontal", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "thumbHorizontal", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "trackVertical", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "thumbVertical", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "size", new _size["default"]());
    _defineProperty(_this, "position", new _position["default"]());
    _defineProperty(_this, "state", {
      horizontalTrackBackground: "transparent"
    });
    _defineProperty(_this, "raf", _raf["default"]);
    _defineProperty(_this, "caf", _raf.cancel);
    _defineProperty(_this, "getValues", function () {
      var _ref = _this.view.current || {},
        _ref$scrollLeft = _ref.scrollLeft,
        scrollLeft = _ref$scrollLeft === void 0 ? 0 : _ref$scrollLeft,
        _ref$scrollTop = _ref.scrollTop,
        scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop,
        _ref$scrollWidth = _ref.scrollWidth,
        scrollWidth = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth,
        _ref$scrollHeight = _ref.scrollHeight,
        scrollHeight = _ref$scrollHeight === void 0 ? 0 : _ref$scrollHeight,
        _ref$clientWidth = _ref.clientWidth,
        clientWidth = _ref$clientWidth === void 0 ? 0 : _ref$clientWidth,
        _ref$clientHeight = _ref.clientHeight,
        clientHeight = _ref$clientHeight === void 0 ? 0 : _ref$clientHeight;
      return {
        left: scrollLeft / (scrollWidth - clientWidth) || 0,
        top: scrollTop / (scrollHeight - clientHeight) || 0,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth,
        scrollHeight: scrollHeight,
        clientWidth: clientWidth,
        clientHeight: clientHeight
      };
    });
    _defineProperty(_this, "getThumbHorizontalWidth", function () {
      var _this$props = _this.props,
        thumbSize = _this$props.thumbSize,
        thumbMinSize = _this$props.thumbMinSize;
      var _this$view$current = _this.view.current,
        scrollWidth = _this$view$current.scrollWidth,
        clientWidth = _this$view$current.clientWidth;
      var trackWidth = _this.size.getInnerWidth(_this.trackHorizontal.current);
      var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
      if (trackWidth <= width) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(width, thumbMinSize);
    });
    _defineProperty(_this, "getThumbVerticalHeight", function () {
      var _this$props2 = _this.props,
        thumbSize = _this$props2.thumbSize,
        thumbMinSize = _this$props2.thumbMinSize;
      var _this$view$current2 = _this.view.current,
        scrollHeight = _this$view$current2.scrollHeight,
        clientHeight = _this$view$current2.clientHeight;
      var trackHeight = _this.size.getInnerHeight(_this.trackVertical.current);
      var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
      if (trackHeight <= height) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(height, thumbMinSize);
    });
    _defineProperty(_this, "getScrollLeftForOffset", function (offset) {
      var _this$view$current3 = _this.view.current,
        scrollWidth = _this$view$current3.scrollWidth,
        clientWidth = _this$view$current3.clientWidth;
      var trackWidth = _this.size.getInnerWidth(_this.trackHorizontal.current);
      var thumbWidth = _this.getThumbHorizontalWidth();
      return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
    });
    _defineProperty(_this, "getScrollTopForOffset", function (offset) {
      var _this$view$current4 = _this.view.current,
        scrollHeight = _this$view$current4.scrollHeight,
        clientHeight = _this$view$current4.clientHeight;
      var trackHeight = _this.size.getInnerHeight(_this.trackVertical.current);
      var thumbHeight = _this.getThumbVerticalHeight();
      return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
    });
    _defineProperty(_this, "scrollCallback", function (values) {
      var onScrollFrame = _this.props.onScrollFrame;
      _this.viewScrollLeft = values.scrollLeft;
      _this.viewScrollTop = values.scrollTop;

      /**
       * If enabled, fire a scroll event on the window so any other components can
       * act on the scroll event without directly hooking into methods in this class.
       */
      if (_this.props.fireWindowScrollEvents) {
        if (_this.lastViewScrollLeft !== undefined && _this.lastViewScrollLeft !== _this.viewScrollLeft) {
          var event = new CustomEvent("scroll", {
            detail: "horizontal"
          });
          _this.window.dispatchEvent(event);
        }
        if (_this.lastViewScrollTop !== undefined && _this.lastViewScrollTop !== _this.viewScrollTop) {
          var _event = new CustomEvent("scroll", {
            detail: "vertical"
          });
          _this.window.dispatchEvent(_event);
        }
      }

      /* istanbul ignore else */
      if (onScrollFrame) onScrollFrame(values);
    });
    _defineProperty(_this, "handleScroll", function (event) {
      var onScroll = _this.props.onScroll;

      /* istanbul ignore else */
      if (onScroll) onScroll(event);
      _this.update(_this.scrollCallback);
      _this.detectScrolling();
    });
    _defineProperty(_this, "handleWindowResize", function () {
      _this.size.getScrollbarWidth(false);
      _this.forceUpdate();
    });
    _defineProperty(_this, "handleHorizontalTrackMouseDown", function (event) {
      event.preventDefault();
      var target = event.target,
        clientX = event.clientX;
      var _target$getBoundingCl = target.getBoundingClientRect(),
        targetLeft = _target$getBoundingCl.left;
      var thumbWidth = _this.getThumbHorizontalWidth();
      var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
      _this.view.current.scrollLeft = _this.getScrollLeftForOffset(offset);
    });
    _defineProperty(_this, "handleVerticalTrackMouseDown", function (event) {
      event.preventDefault();
      var target = event.target,
        clientY = event.clientY;
      var _target$getBoundingCl2 = target.getBoundingClientRect(),
        targetTop = _target$getBoundingCl2.top;
      var thumbHeight = _this.getThumbVerticalHeight();
      var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
      _this.view.current.scrollTop = _this.getScrollTopForOffset(offset);
    });
    _defineProperty(_this, "handleHorizontalThumbMouseDown", function (event) {
      event.preventDefault();
      _this.handleDragStart(event);
      var target = event.target,
        clientX = event.clientX;
      var offsetWidth = target.offsetWidth;
      var _target$getBoundingCl3 = target.getBoundingClientRect(),
        left = _target$getBoundingCl3.left;
      _this.prevPageX = offsetWidth - (clientX - left);
    });
    _defineProperty(_this, "handleVerticalThumbMouseDown", function (event) {
      event.preventDefault();
      _this.handleDragStart(event);
      var target = event.target,
        clientY = event.clientY;
      var offsetHeight = target.offsetHeight;
      var _target$getBoundingCl4 = target.getBoundingClientRect(),
        top = _target$getBoundingCl4.top;
      _this.prevPageY = offsetHeight - (clientY - top);
    });
    _defineProperty(_this, "handleDrag", function (event) {
      if (_this.prevPageX) {
        var clientX = event.clientX;
        var _this$trackHorizontal = _this.trackHorizontal.current.getBoundingClientRect(),
          trackLeft = _this$trackHorizontal.left;
        var thumbWidth = _this.getThumbHorizontalWidth();
        var clickPosition = thumbWidth - _this.prevPageX;
        var offset = -trackLeft + clientX - clickPosition;
        _this.view.current.scrollLeft = _this.getScrollLeftForOffset(offset);
      }
      if (_this.prevPageY) {
        var clientY = event.clientY;
        var _this$trackVertical$c = _this.trackVertical.current.getBoundingClientRect(),
          trackTop = _this$trackVertical$c.top;
        var thumbHeight = _this.getThumbVerticalHeight();
        var _clickPosition = thumbHeight - _this.prevPageY;
        var _offset = -trackTop + clientY - _clickPosition;
        _this.view.current.scrollTop = _this.getScrollTopForOffset(_offset);
      }
      return false;
    });
    _defineProperty(_this, "handleDragEnd", function () {
      _this.dragging = false;
      _this.prevPageX = _this.prevPageY = 0;
      _this.teardownDragging();
      _this.handleDragEndAutoHide();
    });
    _defineProperty(_this, "handleTrackMouseEnter", function () {
      _this.trackMouseOver = true;
      _this.handleTrackMouseEnterAutoHide();
    });
    _defineProperty(_this, "handleTrackMouseLeave", function () {
      _this.trackMouseOver = false;
      _this.handleTrackMouseLeaveAutoHide();
    });
    _defineProperty(_this, "setScrollStop", function () {
      if (_this.lastViewScrollLeft === _this.viewScrollLeft && _this.lastViewScrollTop === _this.viewScrollTop) {
        clearInterval(_this.detectScrollingInterval);
        _this.scrolling = false;
        _this.handleScrollStop();
      }
      _this.lastViewScrollLeft = _this.viewScrollLeft;
      _this.lastViewScrollTop = _this.viewScrollTop;
    });
    return _this;
  }
  _inherits(Scrollbars, _Component);
  return _createClass(Scrollbars, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners();
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
      this.getHorizontalTrackBackground();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      this.caf(this.requestFrame);
      clearTimeout(this.hideTracksTimeout);
      clearInterval(this.detectScrollingInterval);
    }
  }, {
    key: "scrollTop",
    value: function scrollTop() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.view) return null;
      this.view.current.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      /* istanbul ignore if */
      if (typeof this.document === "undefined" || !this.view) return;
      var view = this.view,
        trackHorizontal = this.trackHorizontal,
        trackVertical = this.trackVertical,
        thumbHorizontal = this.thumbHorizontal,
        thumbVertical = this.thumbVertical;
      view.current.addEventListener("scroll", this.handleScroll);
      /* istanbul ignore else */
      if (this.size.getScrollbarWidth() > 0) {
        trackHorizontal.current.addEventListener("mouseenter", this.handleTrackMouseEnter);
        trackHorizontal.current.addEventListener("mouseleave", this.handleTrackMouseLeave);
        trackHorizontal.current.addEventListener("mousedown", this.handleHorizontalTrackMouseDown);
        trackVertical.current.addEventListener("mouseenter", this.handleTrackMouseEnter);
        trackVertical.current.addEventListener("mouseleave", this.handleTrackMouseLeave);
        trackVertical.current.addEventListener("mousedown", this.handleVerticalTrackMouseDown);
        thumbHorizontal.current.addEventListener("mousedown", this.handleHorizontalThumbMouseDown);
        thumbVertical.current.addEventListener("mousedown", this.handleVerticalThumbMouseDown);
        this.window.addEventListener("resize", this.handleWindowResize);
        new MutationObserver(this.handleWindowResize.bind(this)).observe(view.current, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      /* istanbul ignore if */
      if (typeof this.document === "undefined" || !this.view) return;
      var view = this.view,
        trackHorizontal = this.trackHorizontal,
        trackVertical = this.trackVertical,
        thumbHorizontal = this.thumbHorizontal,
        thumbVertical = this.thumbVertical;
      view.current.removeEventListener("scroll", this.handleScroll);
      /* istanbul ignore else */
      if (this.size.getScrollbarWidth() > 0) {
        trackHorizontal.current.removeEventListener("mouseenter", this.handleTrackMouseEnter);
        trackHorizontal.current.removeEventListener("mouseleave", this.handleTrackMouseLeave);
        trackHorizontal.current.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown);
        trackVertical.current.removeEventListener("mouseenter", this.handleTrackMouseEnter);
        trackVertical.current.removeEventListener("mouseleave", this.handleTrackMouseLeave);
        trackVertical.current.removeEventListener("mousedown", this.handleVerticalTrackMouseDown);
        thumbHorizontal.current.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown);
        thumbVertical.current.removeEventListener("mousedown", this.handleVerticalThumbMouseDown);
        this.window.removeEventListener("resize", this.handleWindowResize);

        // Possibly setup by `handleDragStart`
        this.teardownDragging();
      }
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart() {
      var onScrollStart = this.props.onScrollStart;

      /* istanbul ignore else */
      if (onScrollStart) onScrollStart();
      this.handleScrollStartAutoHide();
    }
  }, {
    key: "handleScrollStartAutoHide",
    value: function handleScrollStartAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: "handleScrollStop",
    value: function handleScrollStop() {
      var onScrollStop = this.props.onScrollStop;

      /* istanbul ignore else */
      if (onScrollStop) onScrollStop();
      this.handleScrollStopAutoHide();
    }
  }, {
    key: "handleScrollStopAutoHide",
    value: function handleScrollStopAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "setupDragging",
    value: function setupDragging() {
      (0, _domCss["default"])(this.document.body, {
        userSelect: "none"
      });
      this.document.addEventListener("mousemove", this.handleDrag);
      this.document.addEventListener("mouseup", this.handleDragEnd);
      this.document.onselectstart = function () {
        return false;
      };
    }
  }, {
    key: "teardownDragging",
    value: function teardownDragging() {
      (0, _domCss["default"])(this.document.body, {
        userSelect: ""
      });
      this.document.removeEventListener("mousemove", this.handleDrag);
      this.document.removeEventListener("mouseup", this.handleDragEnd);
      this.document.onselectstart = undefined;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      this.dragging = true;
      event.stopImmediatePropagation();
      this.setupDragging();
    }
  }, {
    key: "handleDragEndAutoHide",
    value: function handleDragEndAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "handleTrackMouseEnterAutoHide",
    value: function handleTrackMouseEnterAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: "handleTrackMouseLeaveAutoHide",
    value: function handleTrackMouseLeaveAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "showTracks",
    value: function showTracks() {
      clearTimeout(this.hideTracksTimeout);
      (0, _domCss["default"])(this.trackHorizontal.current, {
        opacity: 1
      });
      (0, _domCss["default"])(this.trackVertical.current, {
        opacity: 1
      });
    }
  }, {
    key: "setTrackOpacity",
    value: function setTrackOpacity() {
      (0, _domCss["default"])(this.trackHorizontal.current, {
        opacity: 0
      });
      (0, _domCss["default"])(this.trackVertical.current, {
        opacity: 0
      });
    }
  }, {
    key: "hideTracks",
    value: function hideTracks() {
      if (this.dragging) return;
      if (this.scrolling) return;
      if (this.trackMouseOver) return;
      var autoHideTimeout = this.props.autoHideTimeout;
      clearTimeout(this.hideTracksTimeout);
      this.hideTracksTimeout = setTimeout(this.setTrackOpacity, autoHideTimeout);
    }
  }, {
    key: "detectScrolling",
    value: function detectScrolling() {
      if (this.scrolling) return;
      this.scrolling = true;
      this.handleScrollStart();
      this.detectScrollingInterval = setInterval(this.setScrollStop, 100);
    }
  }, {
    key: "rafReset",
    value: function rafReset(callback) {
      this.requestFrame = undefined;
      callback();
    }
  }, {
    key: "setRaf",
    value: function setRaf(callback) {
      var _this2 = this;
      if (this.requestFrame) this.raf.cancel(this.requestFrame);
      /* istanbul ignore next */
      this.requestFrame = this.raf(function () {
        return _this2.rafReset(callback);
      });
    }
  }, {
    key: "update",
    value: function update(callback) {
      var _this3 = this;
      /* istanbul ignore next */
      this.setRaf(function () {
        return _this3.updateStyles(callback);
      });
    }
  }, {
    key: "updateStyles",
    value: function updateStyles(callback) {
      var values = this.getValues();
      if (this.size.getScrollbarWidth()) {
        var thumbHorizontalWidth = this.getThumbHorizontalWidth();
        var thumbVerticalHeight = this.getThumbVerticalHeight();
        this.setThumbStyle(values, thumbHorizontalWidth, thumbVerticalHeight);
        this.setContainerPadding(thumbHorizontalWidth, thumbVerticalHeight);
      }
      if (this.props.onUpdate) {
        this.props.onUpdate(values);
      }
      if (typeof callback !== "function") return;
      callback(values);
    }
  }, {
    key: "setThumbStyle",
    value: function setThumbStyle(values, thumbHorizontalWidth, thumbVerticalHeight) {
      var scrollLeft = values.scrollLeft,
        clientWidth = values.clientWidth,
        scrollWidth = values.scrollWidth;
      var trackHorizontalWidth = this.size.getInnerWidth(this.trackHorizontal.current);
      var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
      var scrollTop = values.scrollTop,
        clientHeight = values.clientHeight,
        scrollHeight = values.scrollHeight;
      var trackVerticalHeight = this.size.getInnerHeight(this.trackVertical.current);
      var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
      var thumbHorizontalStyle = {
        width: thumbHorizontalWidth,
        left: "".concat(thumbHorizontalX, "px")
      };
      var thumbVerticalStyle = {
        height: thumbVerticalHeight,
        top: "".concat(thumbVerticalY, "px")
      };
      (0, _domCss["default"])(this.thumbHorizontal.current, thumbHorizontalStyle);
      (0, _domCss["default"])(this.thumbVertical.current, thumbVerticalStyle);
    }
  }, {
    key: "setContainerPadding",
    value: function setContainerPadding(thumbHorizontalWidth, thumbVerticalHeight) {
      var trackPadding = this.props.trackPadding;
      var containerPadding = {
        paddingBottom: 0,
        paddingRight: 0
      };
      if (thumbHorizontalWidth > 0) {
        containerPadding.paddingBottom = trackPadding;
      }
      if (thumbVerticalHeight > 0) {
        containerPadding.paddingRight = trackPadding;
      }
      (0, _domCss["default"])(this.container.current, containerPadding);
    }
  }, {
    key: "getViewStyle",
    value: function getViewStyle() {
      var scrollbarWidth = this.size.getScrollbarWidth();
      var _this$props3 = this.props,
        autoHeight = _this$props3.autoHeight,
        autoHeightMin = _this$props3.autoHeightMin,
        autoHeightMax = _this$props3.autoHeightMax;
      /* eslint-enable no-unused-vars */

      return _objectSpread({
        // Hide scrollbars by setting a negative margin
        marginRight: -scrollbarWidth,
        marginBottom: -scrollbarWidth
      }, autoHeight && _objectSpread(_objectSpread({}, {
        position: "relative",
        top: undefined,
        left: undefined,
        right: undefined,
        bottom: undefined
      }), {}, {
        // Add scrollbarWidth to autoHeight in order to compensate negative margins
        minHeight: _utilities.utilities.isString(autoHeightMin) ? "calc(".concat(autoHeightMin, " + ").concat(scrollbarWidth, "px)") : autoHeightMin + scrollbarWidth,
        maxHeight: _utilities.utilities.isString(autoHeightMax) ? "calc(".concat(autoHeightMax, " + ").concat(scrollbarWidth, "px)") : autoHeightMax + scrollbarWidth
      }));
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var _this$props4 = this.props,
        autoHeight = _this$props4.autoHeight,
        autoHeightMin = _this$props4.autoHeightMin,
        autoHeightMax = _this$props4.autoHeightMax,
        style = _this$props4.style;
      /* eslint-enable no-unused-vars */

      return _objectSpread(_objectSpread({}, autoHeight && {
        height: "auto",
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }), style);
    }
  }, {
    key: "getTrackAutoHeightStyle",
    value: function getTrackAutoHeightStyle() {
      var autoHideDuration = this.props.autoHideDuration;
      return {
        transition: "opacity ".concat(autoHideDuration, "ms"),
        opacity: 0
      };
    }
  }, {
    key: "getThumbWidth",
    value: function getThumbWidth() {
      var box = this.position.getNodeBox(this.thumbHorizontal.current);
      return box ? box.width : 0;
    }
  }, {
    key: "getHorizontalTrackBackground",
    value: function getHorizontalTrackBackground() {
      var trackBackground = this.props.trackBackground;
      var scrollbarWidth = this.size.getScrollbarWidth();
      var background = "transparent";
      if (trackBackground && scrollbarWidth && this.getThumbWidth() > 0) {
        background = "rgba(0,0,0,0.1)";
      }
      if (background && background !== this.state.horizontalTrackBackground) {
        this.setState({
          horizontalTrackBackground: background
        });
      }
    }
  }, {
    key: "getHorizontalTrackStyle",
    value: function getHorizontalTrackStyle() {
      var scrollbarWidth = this.size.getScrollbarWidth();

      /* eslint-disable no-unused-vars */
      var autoHide = this.props.autoHide;
      /* eslint-enable no-unused-vars */

      return _objectSpread(_objectSpread(_objectSpread({}, {
        position: "absolute",
        height: 4,
        background: this.state.horizontalTrackBackground
      }), autoHide && this.getTrackAutoHeightStyle()), !scrollbarWidth && {
        display: "none",
        height: 0
      });
    }
  }, {
    key: "getVerticalTrackStyle",
    value: function getVerticalTrackStyle() {
      var scrollbarWidth = this.size.getScrollbarWidth();

      /* eslint-disable no-unused-vars */
      var autoHide = this.props.autoHide;
      /* eslint-enable no-unused-vars */

      return _objectSpread(_objectSpread(_objectSpread({}, {
        position: "absolute",
        width: 4
      }), autoHide && this.getTrackAutoHeightStyle()), !scrollbarWidth && {
        display: "none"
      });
    }
  }, {
    key: "getContainerProps",
    value: function getContainerProps() {
      /* eslint-disable no-unused-vars */
      var _this$props5 = this.props,
        onScroll = _this$props5.onScroll,
        onScrollFrame = _this$props5.onScrollFrame,
        onScrollStart = _this$props5.onScrollStart,
        onScrollStop = _this$props5.onScrollStop,
        onUpdate = _this$props5.onUpdate,
        tagName = _this$props5.tagName,
        autoHide = _this$props5.autoHide,
        autoHideTimeout = _this$props5.autoHideTimeout,
        autoHideDuration = _this$props5.autoHideDuration,
        thumbSize = _this$props5.thumbSize,
        thumbMinSize = _this$props5.thumbMinSize,
        universal = _this$props5.universal,
        autoHeight = _this$props5.autoHeight,
        autoHeightMin = _this$props5.autoHeightMin,
        autoHeightMax = _this$props5.autoHeightMax,
        style = _this$props5.style,
        trackPadding = _this$props5.trackPadding,
        trackBackground = _this$props5.trackBackground,
        children = _this$props5.children,
        fireWindowScrollEvents = _this$props5.fireWindowScrollEvents,
        props = _objectWithoutProperties(_this$props5, _excluded);
      /* eslint-enable no-unused-vars */

      return props;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        tagName = _this$props6.tagName,
        children = _this$props6.children;

      //TODO apple devices use own scrollbars

      var Container = tagName;
      return /*#__PURE__*/_react["default"].createElement(Container, _extends({}, this.getContainerProps(), {
        className: _scrollbarModule["default"].container,
        style: this.getContainerStyle(),
        "data-testid": "scrollbarContainer",
        ref: this.container
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _scrollbarModule["default"].innerContainer,
        style: this.getContainerStyle()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _scrollbarModule["default"].view,
        style: this.getViewStyle(),
        key: "view",
        "data-testid": "scrollbarView",
        ref: this.view
      }, children)), /*#__PURE__*/_react["default"].createElement("div", {
        style: this.getHorizontalTrackStyle(),
        className: _scrollbarModule["default"].horizontalTract,
        key: "trackHorizontal",
        "data-testid": "scrollbarTrackHorizontal",
        ref: this.trackHorizontal
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _scrollbarModule["default"].horizontalThumb,
        "data-testid": "scrollbarThumbHorizontal",
        ref: this.thumbHorizontal
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: this.getVerticalTrackStyle(),
        className: _scrollbarModule["default"].verticalTrack,
        key: "trackVertical",
        "data-testid": "scrollbarTrackVertical",
        ref: this.trackVertical
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _scrollbarModule["default"].verticalThumb,
        "data-testid": "scrollbarThumbVertical",
        ref: this.thumbVertical
      })));
    }
  }]);
}(_react.Component);
Scrollbars.propTypes = {
  onScroll: _propTypes["default"].func,
  onScrollFrame: _propTypes["default"].func,
  onScrollStart: _propTypes["default"].func,
  onScrollStop: _propTypes["default"].func,
  tagName: _propTypes["default"].string,
  thumbSize: _propTypes["default"].number,
  thumbMinSize: _propTypes["default"].number,
  autoHide: _propTypes["default"].bool,
  autoHideTimeout: _propTypes["default"].number,
  autoHideDuration: _propTypes["default"].number,
  autoHeight: _propTypes["default"].bool,
  autoHeightMin: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  autoHeightMax: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  style: _propTypes["default"].object,
  trackPadding: _propTypes["default"].number,
  trackBackground: _propTypes["default"].bool,
  fireWindowScrollEvents: _propTypes["default"].bool,
  children: _propTypes["default"].node
};
Scrollbars.defaultProps = {
  tagName: "div",
  thumbMinSize: 30,
  autoHide: false,
  autoHideTimeout: 1000,
  autoHideDuration: 200,
  autoHeight: false,
  autoHeightMin: 0,
  autoHeightMax: 1500,
  trackPadding: 0,
  trackBackground: false,
  fireWindowScrollEvents: true
};
var _default = exports["default"] = Scrollbars;